import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { getCarousel, type CarouselVariables, type RecommendationType } from './getCarousel';
import { carouselProductsQuery, recommendedProductsQuery } from './queries';
import { carouselProductMapper } from '../mappers/common/carouselProductMapper';

import { useEnvironment } from '@/context/EnvironmentContext';
import { useLocale } from '@/context/LocaleContext';

const useCarousel = (query: string, variables?: CarouselVariables) => {
  const { locale } = useLocale();
  const { environment } = useEnvironment();

  return useQuery({
    queryKey: ['carousel', query, variables, locale, environment],
    queryFn: () => getCarousel({ query, variables: variables!, locale, environment }),
    enabled: !!variables,
    placeholderData: variables ? keepPreviousData : undefined,
    select: ({ products }) => products.map(carouselProductMapper.select),
  });
};

export const useCarouselProducts = (identifiers?: string[]) =>
  useCarousel(carouselProductsQuery, identifiers && { identifiers });

export const useRecommendedProducts = (sku: string | undefined, type: RecommendationType) =>
  useCarousel(recommendedProductsQuery, sku ? { sku, type } : undefined);
